import { useQuery } from '@tanstack/react-query';

import { useIamApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';
import useServiceAppState from './useServiceAppState';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { ResponseCloudProject } from '../api';

type UseAccessibleProjectOptions = UseQueryOptions<ResponseCloudProject[]>;

/**
 * 현재 사용자가 접근할 수 있는 프로젝트 목록을 제공하는 훅입니다.
 * @description
 * - Iam Api의 응답값을 react-query로 제공합니다.
 * - SSR을 지원하고 있습니다.
 * - queryKey를 기반으로 revalidate 할 수 있습니다.
 */
const useAccessibleProject = (options?: UseAccessibleProjectOptions) => {
  const {
    state: { userId },
  } = useServiceAppState();
  const { fetchProjects } = useIamApiInstance();

  return useQuery<ResponseCloudProject[]>({
    queryKey: [HOST_QUERY_KEY.GET_IAM_ACCESSIBLE_PROJECT_LIST],
    queryFn: () => fetchProjects({ userId }),
    staleTime: Infinity,
    ...options,
  });
};

export default useAccessibleProject;
